export interface ItemLookupOption {
  id: number
  nameEn: string
  nameAr: string
}

/** MaterialTypes lookup named Goods (used for stock/batch items). */
export function formatItemDisplayLabel(
  item:
    | {
        itemCode?: string | null
        itemNameEn?: string | null
        itemNameAr?: string | null
        itemName?: string | null
      }
    | undefined,
  lang: string,
  id: number,
): string {
  if (!id || id <= 0) return ''
  if (!item) return `Item #${id}`
  const useAr = String(lang || '').toLowerCase().startsWith('ar')
  const name = useAr
    ? item.itemNameAr || item.itemNameEn || item.itemName
    : item.itemNameEn || item.itemNameAr || item.itemName
  const code = String(item.itemCode || '').trim()
  const nameTrim = String(name || '').trim()
  if (code && nameTrim) return `${code} — ${nameTrim}`
  if (nameTrim) return nameTrim
  if (code) return code
  return `Item #${id}`
}

export function isGoodsMaterialType(lookup: Pick<ItemLookupOption, 'nameEn' | 'nameAr'>): boolean {
  const en = String(lookup.nameEn || '').trim().toLowerCase()
  const ar = String(lookup.nameAr || '').trim().toLowerCase()
  if (en === 'goods' || en === 'good') return true
  if (ar === 'بضاعة' || ar.includes('بضاع') || ar.includes('سلع')) return true
  return false
}

export interface ItemEntity {
  itemId: number
  itemNameEn: string
  itemNameAr: string
  itemCode: string
  reference: string
  itemCategoryId: number
  sku: string
  barcode: string
  tags: string
  shelfId: string
  description: string
  subCategoryId: number
  uom: number
  type: number
  costMethod: number
  isTaxable: boolean
  unitSellingPrice: number
  unitCostPrice: number
  tax: number
  sellingTax: number
  attachmentUrl?: string
  createdDate?: string
  createdBy?: number
  modifiedDate?: string
  modifiedBy?: number
  branchId: number
}

export interface ItemListResponse {
  items: ItemEntity[]
  totalCount: number
}

export interface ItemUpsertPayload {
  itemId: number
  itemNameEn: string
  itemNameAr: string
  itemCode: string
  reference: string
  itemCategoryId: number
  sku: string
  barcode: string
  tags: string
  shelfId: string
  description: string
  subCategoryId: number
  uom: number
  type: number
  costMethod: number
  isTaxable: boolean
  unitSellingPrice: number
  unitCostPrice: number
  tax: number
  sellingTax: number
  attachmentFile?: File | null
  createdDate?: string
  createdBy?: number
  modifiedDate?: string
  modifiedBy?: number
  branchId: number
}
